import styled from "styled-components";
import { White, White03, White05 } from "./colors";

export const ShareContainer = styled.div`
  border-radius: 20px;
  margin-top: 0px;
  padding: 15px 10px 15px;
  width: 100%;
  color: ${White};
`;

export const ButtonBox = styled.div`
  border-radius: 20px;
  margin-top: 15px;
  padding: 10px 10px 15px;
  width: 100%;
`;

export const DrawerLine = styled.div`
  background-color: ${White03};
  width: 100px;
  height: 8px;
  margin-top: 15px;
  border-radius: 20px;
`;

export const LineOR = styled.div`
  display: flex;
  align-items: center;
  text-align: center;
  color: ${White05};
  font-size: 12px;
  margin: 0 auto 15px;
  width: 100%;

  &::before,
  &::after {
    content: "";
    flex: 1;
    border-bottom: 1px solid ${White05};
  }

  &::before {
    margin-right: 12px;
  }

  &::after {
    margin-left: 12px;
  }
`;
